import type {SVGProps} from 'react'
const ScanIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 1000 1000"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M375.2 671L375.2 329L342.7 329L342.7 671L375.2 671ZM499.1 671L499.1 329L416.2 329L416.2 671L499.1 671ZM573.5 671L573.5 329L540.2 329L540.2 671L573.5 671ZM647.1 671L647.1 329L613.7 329L613.7 671L647.1 671ZM757.4 671L757.4 329L687.2 329L687.2 671L757.4 671ZM301.6 671L301.6 329L243.5 329L243.5 671L301.6 671ZM158 329L158 200.8L286.3 200.8L286.3 158L158 158Q141.8 158 128.5 171.3Q115.3 184.5 115.3 200.8L115.3 200.8L115.3 329L158 329ZM286.3 799.3L158 799.3L158 671L115.3 671L115.3 799.3Q115.3 815.5 128.5 828.7Q141.8 842 158 842L158 842L286.3 842L286.3 799.3ZM842 671L842 799.3L713.8 799.3L713.8 842L842 842Q858.2 842 871.5 828.7Q884.8 815.5 884.8 799.3L884.8 799.3L884.8 671L842 671ZM713.8 200.8L842 200.8L842 329L884.8 329L884.8 200.8Q884.8 184.5 871.5 171.3Q858.2 158 842 158L842 158L713.8 158L713.8 200.8Z" />
  </svg>
)
export {ScanIcon}
